export var DetectorType;
(function (DetectorType) {
    DetectorType["Malware"] = "MALWARE";
    DetectorType["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    DetectorType["DataAnomaly"] = "DATA_ANOMALY";
    DetectorType["AiDataRisk"] = "AI_DATA_RISK";
    DetectorType["DataExposureRisk"] = "DATA_EXPOSURE_RISK";
})(DetectorType || (DetectorType = {}));
